// /* eslint-disable */
// 'use client';

// import {
//   Box, Flex, Text, useColorModeValue, Table, Thead, Tbody, Tr, Th, Td,
//   Badge, Button, Input, Switch, useToast, Modal, ModalOverlay, Select,
//   ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
//   FormControl, FormLabel, useDisclosure, Textarea, IconButton, Stack, Spinner
// } from '@chakra-ui/react';
// import axios from 'axios';
// import * as React from 'react';
// import { EditIcon, AddIcon, DeleteIcon, SmallAddIcon } from '@chakra-ui/icons';
// import Card from 'components/card/Card';

// export default function SubscriptionPlans() {
//   const [plans, setPlans] = React.useState([]);
//   const [editingPlan, setEditingPlan] = React.useState(null);
//   const [loading, setLoading] = React.useState(true);
//   const [saving, setSaving] = React.useState(false);

//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const toast = useToast();

//   const textColor = useColorModeValue('secondaryGray.900', 'white');
//   const baseUrl = process.env.REACT_APP_BASE_URL;
//   const token = localStorage.getItem('token');

//   // Form Initial State
//   const initialForm = {
//     name: '',
//     features: '',
//     pricing: [{ months: 1, price: '' }],
//     isActive: true,
//   };

//   const [formData, setFormData] = React.useState(initialForm);

//   // 🟢 1. Fetch Plans (Backend Endpoint: /api/plans/admin/all-plans)
//   const fetchPlans = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${baseUrl}/api/plans/admin/all-plans`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response.data.status) {
//         setPlans(response.data.data);
//       }
//     } catch (err) {
//       console.error("Fetch Error:", err);
//       toast({ title: 'Error loading plans', description: 'Backend connection failed', status: 'error', position: 'top-right' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   React.useEffect(() => { fetchPlans(); }, []);

//   // 🟢 2. Pricing Row Handlers
//   const addPricingRow = () => {
//     setFormData({ ...formData, pricing: [...formData.pricing, { months: 1, price: '' }] });
//   };

//   const removePricingRow = (index) => {
//     const newPricing = formData.pricing.filter((_, i) => i !== index);
//     setFormData({ ...formData, pricing: newPricing });
//   };

//   const handlePricingChange = (index, field, value) => {
//     const newPricing = [...formData.pricing];
//     newPricing[index][field] = field === 'price' ? value : Number(value);
//     setFormData({ ...formData, pricing: newPricing });
//   };

//   // 🟢 3. Modal Controls
//   const handleOpenModal = (plan = null) => {
//     if (plan) {
//       setEditingPlan(plan);
//       setFormData({
//         name: plan.name,
//         isActive: plan.isActive,
//         features: plan.features?.join(', ') || '',
//         pricing: plan.pricing?.length > 0 ? plan.pricing : [{ months: 1, price: '' }],
//       });
//     } else {
//       setEditingPlan(null);
//       setFormData(initialForm);
//     }
//     onOpen();
//   };

//   // 🟢 4. Save Logic (Backend Endpoints: /create-plan & /update-plan)
//   const handleSave = async () => {
//     if (!formData.name || formData.pricing.some(p => !p.price)) {
//       return toast({ title: "Validation Error", description: "Please fill all fields", status: "warning" });
//     }

//     setSaving(true);
//     try {
//       const payload = {
//         ...formData,
//         pricing: formData.pricing.map(p => ({ months: Number(p.months), price: Number(p.price) })),
//         features: formData.features.split(',').map(f => f.trim()).filter(f => f !== ''),
//       };

//       // Match your backend route structure
//       const url = editingPlan
//         ? `${baseUrl}/api/plans/update-plan/${editingPlan._id}`
//         : `${baseUrl}/api/plans/create-plan`;

//       const method = editingPlan ? 'put' : 'post';

//       const response = await axios[method](url, payload, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (response.data.status) {
//         toast({ title: 'Plan Saved Successfully', status: 'success' });
//         fetchPlans();
//         onClose();
//       }
//     } catch (err) {
//       toast({ title: 'Operation failed', description: err.response?.data?.message || 'Server Error', status: 'error' });
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Card flexDirection="column" w="100%" px="25px" py="25px" mt="80px" boxShadow="lg" borderRadius="20px">
//       <Flex mb="30px" justifyContent="space-between" align="center">
//         <Box>
//           <Text color={textColor} fontSize="22px" fontWeight="700">Subscription Plans</Text>
//           <Text color="secondaryGray.600" fontSize="sm">Manage plan pricing and features</Text>
//         </Box>
//         <Button leftIcon={<AddIcon />} colorScheme="brand" onClick={() => handleOpenModal()}>
//           Create Plan
//         </Button>
//       </Flex>

//       {loading ? (
//         <Flex justify="center" align="center" minH="200px"><Spinner /></Flex>
//       ) : (
//         <Box overflowX="auto">
//           <Table variant="simple" color={textColor}>
//             <Thead bg={useColorModeValue('gray.50', 'navy.800')}>
//               <Tr>
//                 <Th>Plan Name</Th>
//                 <Th>Pricing Tiers (Months : Price)</Th>
//                 <Th>Features</Th>
//                 <Th>Status</Th>
//                 <Th>Actions</Th>
//               </Tr>
//             </Thead>
//             <Tbody>
//               {plans.map((plan) => (
//                 <Tr key={plan._id}>
//                   <Td fontWeight="bold" fontSize="sm">{plan.name}</Td>
//                   <Td>
//                     <Stack direction="row" flexWrap="wrap" gap={2}>
//                       {plan.pricing?.map((p, i) => (
//                         <Badge key={i} colorScheme="purple" variant="subtle" borderRadius="full" px={2}>
//                           {p.months}M : ₹{p.price}
//                         </Badge>
//                       ))}
//                     </Stack>
//                   </Td>
//                   <Td>
//                     <Text noOfLines={1} fontSize="xs" maxW="200px" color="gray.500">
//                       {plan.features?.join(', ')}
//                     </Text>
//                   </Td>
//                   <Td>
//                     <Badge colorScheme={plan.isActive ? 'green' : 'red'}>
//                       {plan.isActive ? 'Active' : 'Inactive'}
//                     </Badge>
//                   </Td>
//                   <Td>
//                     <Flex gap={2}>
//                       <IconButton icon={<EditIcon />} size="sm" variant="outline" onClick={() => handleOpenModal(plan)} aria-label="Edit" />
//                     </Flex>
//                   </Td>
//                 </Tr>
//               ))}
//             </Tbody>
//           </Table>
//         </Box>
//       )}

//       {/* 🟢 Add/Edit Modal */}
//       <Modal isOpen={isOpen} onClose={onClose} size="xl">
//         <ModalOverlay />
//         <ModalContent borderRadius="15px">
//           <ModalHeader borderBottom="1px solid" borderColor="gray.100">
//             {editingPlan ? 'Update Plan Details' : 'Create New Subscription'}
//           </ModalHeader>
//           <ModalCloseButton />
//           <ModalBody py={6}>
//             <Stack spacing={5}>
//               <FormControl isRequired>
//                 <FormLabel fontWeight="600">Plan Name</FormLabel>
//                 <Input placeholder="e.g. Professional Plus" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
//               </FormControl>

//               <Box p={4} bg={useColorModeValue('gray.50', 'whiteAlpha.100')} borderRadius="12px">
//                 <Flex justify="space-between" align="center" mb={4}>
//                   <Text fontWeight="700" fontSize="sm">Pricing Variants</Text>
//                   <Button size="xs" colorScheme="brand" variant="ghost" leftIcon={<SmallAddIcon />} onClick={addPricingRow}>
//                     Add New Row
//                   </Button>
//                 </Flex>

//                 {formData.pricing.map((tier, index) => (
//                   <Flex key={index} gap={3} mb={3} align="center">
//                     <Select flex="1" value={tier.months} onChange={(e) => handlePricingChange(index, 'months', e.target.value)}>
//                       <option value={1}>1 Month</option>
//                       <option value={3}>3 Months</option>
//                       <option value={6}>6 Months</option>
//                       <option value={12}>1 Year</option>
//                       <option value={24}>2 Year</option>
//                     </Select>
//                     <Input flex="1" type="number" placeholder="Price (₹)" value={tier.price} onChange={(e) => handlePricingChange(index, 'price', e.target.value)} />
//                     <IconButton icon={<DeleteIcon />} size="sm" colorScheme="red" variant="ghost" onClick={() => removePricingRow(index)} isDisabled={formData.pricing.length === 1} />
//                   </Flex>
//                 ))}
//               </Box>

//               <FormControl>
//                 <FormLabel fontWeight="600">Plan Features</FormLabel>
//                 <Textarea placeholder="24/7 Support, Premium Content, Unlimited Downloads (Comma separated)" value={formData.features} onChange={(e) => setFormData({ ...formData, features: e.target.value })} />
//               </FormControl>

//               <FormControl display="flex" alignItems="center">
//                 <FormLabel mb="0" fontWeight="600">Is Plan Active?</FormLabel>
//                 <Switch isChecked={formData.isActive} onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })} />
//               </FormControl>
//             </Stack>
//           </ModalBody>

//           <ModalFooter borderTop="1px solid" borderColor="gray.100">
//             <Button variant="ghost" mr={3} onClick={onClose}>Cancel</Button>
//             <Button colorScheme="brand" isLoading={saving} onClick={handleSave} px={8}>
//               {editingPlan ? 'Update Plan' : 'Save Plan'}
//             </Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </Card>
//   );
// }

'use client';

import {
  Box,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  Input,
  Switch,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  FormControl,
  FormLabel,
  useDisclosure,
  IconButton,
  Stack,
  Spinner,
  Stat,
  StatLabel,
  StatNumber,
  StatHelpText,
} from '@chakra-ui/react';

import { EditIcon, AddIcon, DeleteIcon } from '@chakra-ui/icons';
import axios from 'axios';
import * as React from 'react';

export default function DiamondPacks() {
  const [packs, setPacks] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [saving, setSaving] = React.useState(false);
  const [editingPack, setEditingPack] = React.useState(null);
  const [deleteCandidate, setDeleteCandidate] = React.useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();
  const cancelRef = React.useRef();
  const toast = useToast();

  const baseUrl = process.env.REACT_APP_BASE_URL?.replace(/\/+$/, '');
  const token = localStorage.getItem('token');

  const initialForm = {
    name: '',
    price: '',
    diamonds: '',
    isActive: true,
  };

  const [formData, setFormData] = React.useState(initialForm);

  // 🔥 BEST VALUE
  const bestPackId = React.useMemo(() => {
    if (!packs.length) return null;
    return packs.reduce((best, curr) =>
      curr.diamonds / curr.price > best.diamonds / best.price ? curr : best,
    )._id;
  }, [packs]);

  // 📊 STATS
  const totalRevenue = packs.reduce((acc, p) => acc + p.price, 0);
  const totalDiamonds = packs.reduce((acc, p) => acc + p.diamonds, 0);

  // 📡 FETCH
  const fetchPacks = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseUrl}/api/admin/diamond-packs`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) setPacks(res.data.data);
    } catch {
      toast({ title: 'Failed to load', status: 'error' });
    } finally {
      setLoading(false);
    }
  }, [baseUrl, token, toast]);

  React.useEffect(() => {
    fetchPacks();
  }, [fetchPacks]);

  // 🧾 MODAL
  const handleOpen = (pack = null) => {
    if (pack) {
      setEditingPack(pack);
      setFormData(pack);
    } else {
      setEditingPack(null);
      setFormData(initialForm);
    }
    onOpen();
  };

  const handleSave = async () => {
    if (!formData.name || !formData.price || !formData.diamonds) {
      return toast({ title: 'All fields required', status: 'warning' });
    }

    setSaving(true);
    try {
      const payload = {
        ...formData,
        price: Number(formData.price),
        diamonds: Number(formData.diamonds),
      };

      const url = editingPack
        ? `${baseUrl}/api/admin/diamond-packs/${editingPack._id}`
        : `${baseUrl}/api/admin/diamond-packs`;

      const method = editingPack ? 'put' : 'post';

      const res = await axios[method](url, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.success) {
        toast({ title: 'Saved successfully', status: 'success' });
        fetchPacks();
        onClose();
      }
    } catch {
      toast({ title: 'Save failed', status: 'error' });
    } finally {
      setSaving(false);
    }
  };
  const handleDelete = (pack) => {
    setDeleteCandidate(pack);
    onDeleteOpen();
  };

  const confirmDelete = async () => {
    if (!deleteCandidate) return;

    try {
      const res = await axios.delete(
        `${baseUrl}/api/admin/diamond-packs/${deleteCandidate._id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (res.data.success) {
        toast({ title: 'Deleted successfully', status: 'success' });
        fetchPacks(); // refresh list
      }
    } catch {
      toast({ title: 'Delete failed', status: 'error' });
    } finally {
      setDeleteCandidate(null);
      onDeleteClose();
    }
  };
  return (
    <Box
      mt="90px"
      ml={{ base: '0', md: '20px' }}
      p="25px"
      bg="#f8fafc"
      minH="100vh"
    >
      {/* HEADER */}
      <Box
        bgGradient="linear(to-r, green.400, teal.400)"
        p="25px"
        borderRadius="20px"
        color="white"
        mb="25px"
      >
        <Text fontSize="28px" fontWeight="bold">
          💎 Diamond Packs
        </Text>
        <Text opacity={0.9}>Manage your in-app currency packs</Text>
      </Box>

      {/* STATS */}
      <Flex gap="20px" mb="25px" flexWrap="wrap">
        <Stat bg="white" p="20px" borderRadius="15px" boxShadow="sm">
          <StatLabel>Total Revenue</StatLabel>
          <StatNumber>₹{totalRevenue}</StatNumber>
          <StatHelpText>All packs combined</StatHelpText>
        </Stat>

        <Stat bg="white" p="20px" borderRadius="15px" boxShadow="sm">
          <StatLabel>Total Diamonds</StatLabel>
          <StatNumber>{totalDiamonds}</StatNumber>
          <StatHelpText>Across all packs</StatHelpText>
        </Stat>
      </Flex>

      {/* TABLE CARD */}
      <Box bg="white" p="20px" borderRadius="20px" boxShadow="sm">
        <Flex justify="space-between" mb="20px">
          <Text fontWeight="600" fontSize="18px">
            All Packs
          </Text>

          <Button
            leftIcon={<AddIcon />}
            bgGradient="linear(to-r, green.400, teal.400)"
            color="white"
            _hover={{ transform: 'scale(1.05)' }}
            onClick={() => handleOpen()}
          >
            Add Pack
          </Button>
        </Flex>

        {loading ? (
          <Flex justify="center">
            <Spinner />
          </Flex>
        ) : packs.length === 0 ? (
          <Flex justify="center" p="40px">
            <Text color="gray.400">No Packs Found</Text>
          </Flex>
        ) : (
          <Table>
            <Thead bg="gray.50">
              <Tr>
                <Th>Name</Th>
                <Th>Price</Th>
                <Th>Diamonds</Th>
                <Th>Value</Th>
                <Th>Status</Th>
                <Th></Th>
              </Tr>
            </Thead>

            <Tbody>
              {packs.map((p, i) => {
                const isBest = p._id === bestPackId;
                const value = (p.diamonds / p.price).toFixed(2);

                return (
                  <Tr key={p._id} _hover={{ bg: 'green.50' }}>
                    <Td>{p.name}</Td>

                    <Td>₹{p.price}</Td>
                    <Td>💎 {p.diamonds}</Td>
                    <Td>{value}</Td>

                    <Td>
                      <Badge colorScheme={p.isActive ? 'green' : 'red'}>
                        {p.isActive ? 'Active' : 'Inactive'}
                      </Badge>
                    </Td>

                    <Td>
                      <Flex gap="10px">
                        <IconButton
                          icon={<EditIcon />}
                          size="sm"
                          onClick={() => handleOpen(p)}
                        />

                        <IconButton
                          icon={<DeleteIcon />}
                          size="sm"
                          colorScheme="red"
                          onClick={() => handleDelete(p)}
                          aria-label="Delete pack"
                        />
                      </Flex>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        )}
      </Box>

      {/* MODAL */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="20px">
          <ModalHeader>{editingPack ? 'Edit Pack' : 'Create Pack'}</ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            <Stack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                  value={formData.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e.target.value })
                  }
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Price</FormLabel>
                <Input
                  type="number"
                  value={formData.price}
                  onChange={(e) =>
                    setFormData({ ...formData, price: e.target.value })
                  }
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Diamonds</FormLabel>
                <Input
                  type="number"
                  value={formData.diamonds}
                  onChange={(e) =>
                    setFormData({ ...formData, diamonds: e.target.value })
                  }
                />
              </FormControl>

              <Flex justify="space-between">
                <Text>Active</Text>
                <Switch
                  isChecked={formData.isActive}
                  onChange={(e) =>
                    setFormData({ ...formData, isActive: e.target.checked })
                  }
                />
              </Flex>
            </Stack>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="green" isLoading={saving} onClick={handleSave}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <AlertDialog
        isOpen={isDeleteOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => {
          setDeleteCandidate(null);
          onDeleteClose();
        }}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Diamond Pack
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete{' '}
              <strong>{deleteCandidate?.name}</strong>? This action cannot be
              undone.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={() => {
                  setDeleteCandidate(null);
                  onDeleteClose();
                }}
              >
                Cancel
              </Button>
              <Button colorScheme="red" onClick={confirmDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
}
